import { CheckCircleFilled } from '@ant-design/icons'
import { Collapse } from 'antd'

import Box from '~/core/Box'
import Text from '~/core/Text'
import Link from '~/core/Link'
import {
    COLOR_TEXT,
    INSPECTION_TYPES,
    INSPECTION_CRITERIA_LINK,
    BLACK_ALPHA_BOTTOM,
} from '~/apps/consumer/components/PartViewerModal/logic'
import styles from '~/apps/consumer/components/PartViewerModal/styles.css'
import getColor from '~/lib/getColor'

export function VisualCheck(props: { placement: string }) {
    const { placement } = props
    const { Panel } = Collapse

    return (
        <Box borderBottom={BLACK_ALPHA_BOTTOM} direction="col" padding="16px 0">
            <Collapse
                expandIconPosition={'right'}
                bordered={false}
                expandIcon={panelProps => (
                    <Box name="additional-files-link">
                        <Text color={getColor('link')}>
                            {panelProps.isActive ? 'Show less' : 'Show more'}
                        </Text>
                    </Box>
                )}
                className={styles.cardBox}
            >
                <Panel
                    key={INSPECTION_TYPES.VISUAL_INSPECTION}
                    header={
                        <Box direction="row" justifyContent="start">
                            <CheckCircleFilled
                                className={styles.checkCircleStyle}
                            />
                            <Text
                                color={COLOR_TEXT}
                                style={{
                                    paddingLeft: '15px',
                                }}
                            >
                                Visual inspection passed
                            </Text>
                        </Box>
                    }
                    style={{ border: 'none' }}
                >
                    <Box direction="row" flexWrap="wrap">
                        <Text
                            color={COLOR_TEXT}
                            style={{
                                paddingBottom: 8,
                            }}
                        >
                            <p>
                                Parts are within tolerance of dimensional
                                deviation outlined by process specifications.
                            </p>
                            <p>
                                Parts are free of visible warping and sinking.
                            </p>
                            <p>
                                Parts are free of all support structures and
                                residue.
                            </p>
                            <p>Parts are free of broken features and cracks.</p>
                            <p>
                                {' '}
                                Unique parts are consistent in orientation,
                                dimensions, features and color.
                            </p>
                        </Text>
                        <Link
                            target="_blank"
                            href={INSPECTION_CRITERIA_LINK}
                            name="learn-more-inspection-criteria"
                            placement={placement}
                        >
                            Learn more about our inspection criteria
                        </Link>
                    </Box>
                </Panel>
            </Collapse>
        </Box>
    )
}
